import { render, staticRenderFns } from "./OtherQuestionnnaire.vue?vue&type=template&id=444de9e4&scoped=true&"
import script from "./OtherQuestionnnaire.vue?vue&type=script&lang=js&"
export * from "./OtherQuestionnnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444de9e4",
  null
  
)

export default component.exports